import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { DummyStorage } from './dummy-storage';
import * as i0 from "@angular/core";
/**
 * NOTE: Inject BrowserSessionStorage to access sessionStorage.
 * In browser, original window.sessionStorage will be injected instead of BrowserSessionStorage,
 * which is a dummy storage implementation used in SSR env.
 */
export let BrowserSessionStorage = /*#__PURE__*/(() => {
  class BrowserSessionStorage extends DummyStorage {
    constructor() {
      super();
    }
    static {
      this.ɵfac = function BrowserSessionStorage_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BrowserSessionStorage)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: BrowserSessionStorage,
        factory: BrowserSessionStorage.ɵfac
      });
    }
  }
  return BrowserSessionStorage;
})();
export const sessionStorageProvider = {
  provide: BrowserSessionStorage,
  useFactory: platformId => {
    if (isPlatformServer(platformId)) return new BrowserSessionStorage();
    return window.sessionStorage;
  },
  deps: [PLATFORM_ID]
};